export const IntranetRecruitmentRequest = {
    path: '/intranet_recruitment_requests',
    name: 'intranet_recruitment_requests',
    component: () => import('@/views/Intranet/IntranetRecruitmentRequestPage.vue'),
    children: [
        {
            path: '/intranet_recruitment_requests/filter/:id',
            name: 'intranet_recruitment_requests.filter',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestFilteringForm.vue'),
            props: {intranet: true}
        },
        {
            path: '/intranet_recruitment_requests/internal_apply/:id',
            name: 'intranet_recruitment_requests.internal_apply',
            component: () => import('@/views/Request/RecruitmentRequest/Form/RecruitmentRequestInternalApplyForm.vue'),
        },
    ],
}